
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as faqq0Chs_kHkuikdF164tPBHu0as8Rf_5HNxwfC_OK0k48Meta } from "/codebuild/output/src2017366789/src/src/pages/faq.vue?macro=true";
import { default as menuZ6FUqn8XraIZrP6hqlSNSnXJWcXnLrkcGM6GKcw2DzUMeta } from "/codebuild/output/src2017366789/src/src/pages/menu.vue?macro=true";
import { default as indexlbiEBoJ14HGlBB4_453WICk4Tz3zrw7TtZ27VATXcZzacMeta } from "/codebuild/output/src2017366789/src/src/pages/index.vue?macro=true";
import { default as contactUJSenRcD0k8beZTMzwzdLPnXcbhDXHTge3ZwjhqcDKgMeta } from "/codebuild/output/src2017366789/src/src/pages/contact.vue?macro=true";
import { default as tutorial_45otJ1BEXRglJHNheJsob_MEXw4SviwpmzpwIgw0kyYkMeta } from "/codebuild/output/src2017366789/src/src/pages/tutorial.vue?macro=true";
import { default as agreementMtW7MB2qS1kBIIelVMFtvCd_45R9fDr4E22ujwI9VZxEwMeta } from "/codebuild/output/src2017366789/src/src/pages/agreement.vue?macro=true";
import { default as about_45passTKCFX4Tk9vQZQMBDzcnn5mutLMiO_HJ8R1QiO81hCP0Meta } from "/codebuild/output/src2017366789/src/src/pages/about-pass.vue?macro=true";
import { default as indexSUsFquel7BcCsa9pJ89917bXcN9MvA80_0_45cO_gKDxcMeta } from "/codebuild/output/src2017366789/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93cYcwwKKEpx7kTknzuyyXC6W8idBljHGBaY83_45yeQoRAMeta } from "/codebuild/output/src2017366789/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancelPdNkJf5msJYNJuCjuqECvmtgNcowoBlU9RUrxL0yhAMeta } from "/codebuild/output/src2017366789/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93ulOKpJyB6YbxAQDYoa1ZIxCtoMONbS_45o1BIg1kQVMccMeta } from "/codebuild/output/src2017366789/src/src/pages/notice/[id].vue?macro=true";
import { default as indexgACSfaqantiA8U7pMg71Xh8ZAm_45HYgH1uD_45avF_45OU7EMeta } from "/codebuild/output/src2017366789/src/src/pages/coupon/index.vue?macro=true";
import { default as indexZ6Zf0jTET0unpsdghCrbHcm4sRfxLswiERfD6bmux4IMeta } from "/codebuild/output/src2017366789/src/src/pages/mypage/index.vue?macro=true";
import { default as indexZIYjHlFHTXgaukdImp00Bfq3jtjNkU65hRx_45Cp6rex0Meta } from "/codebuild/output/src2017366789/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93Aa7kfihjpU4JZ5VAcJDLfgxk_1hNuhfejebfhpQX79sMeta } from "/codebuild/output/src2017366789/src/src/pages/parking/[id].vue?macro=true";
import { default as indexd6JrO_LTZrH_jW6jQ73urgpwKZdZc6CcAd1J2RR0x28Meta } from "/codebuild/output/src2017366789/src/src/pages/history/index.vue?macro=true";
import { default as indexp6k0VOAAlalW817OMcM7e5J4dhgbrfH8xVY9PZAg6cUMeta } from "/codebuild/output/src2017366789/src/src/pages/monthly/index.vue?macro=true";
import { default as indexxTKi5MuLzvD3u4z2mirb32EV7fXURLU65AwQMwozfBIMeta } from "/codebuild/output/src2017366789/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexaesG6bEMO1cnakJX8BjBoot3O0wdaFxOf_45JIfU6XC_cMeta } from "/codebuild/output/src2017366789/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavi0_45ZLI_U1TYLHJwwrjjLJkDoKKMxnxMTmdUPnd0IuwRIMeta } from "/codebuild/output/src2017366789/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edit_MaHmdq7wkVkbbJv4o9aCUzfsorXhJyoD9Nka1M_igsMeta } from "/codebuild/output/src2017366789/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementW0h7DYiiBOlLTlA60P5f4U_2tUnAY0ao27_45ehwc5Nl8Meta } from "/codebuild/output/src2017366789/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexZe3gkMj9H3Nqbbc6KsoEs048uaIrEb_45gQmLoyskZU9oMeta } from "/codebuild/output/src2017366789/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dBOZHq98sLx16MfC8w0_45Da5DyYrkRPwAUkLvHOfYLMq0Meta } from "/codebuild/output/src2017366789/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmdTkYtTVbb8oPGSRLjOe91vNjhfL525vnBmqPFlGLEXcMeta } from "/codebuild/output/src2017366789/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexkOolzjQs5VdSEBOJ4wqapROPrXOm4Rf_nGw2duRMpUUMeta } from "/codebuild/output/src2017366789/src/src/pages/card/create/index.vue?macro=true";
import { default as indexy36f7DDRYOqErvmKo55Dc_45zulNQ9x8Wfa6p_45Ew5wGEAMeta } from "/codebuild/output/src2017366789/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirm8IXThfYWoI1yaoMTv0WhKrAejsqU1h2uoHIa540T8FUMeta } from "/codebuild/output/src2017366789/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmc5jgC2jMt3LU0uiTIwgT4gth8sGImxU1Jjo6eCaycFsMeta } from "/codebuild/output/src2017366789/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeYugTRwqKKkwJrFJ684VnuuvCHqGU5pf_45ekSQEbKpB0oMeta } from "/codebuild/output/src2017366789/src/src/pages/membership/complete.vue?macro=true";
import { default as registerCG0iYtIUTg81FDA0LFObGzIIsdZ4mD44LehOeauhc7IMeta } from "/codebuild/output/src2017366789/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93nIeWehzXKMw5WCxhoc_qVzz8zs_45Bk03lokrH6ANj7T8Meta } from "/codebuild/output/src2017366789/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmliOpkCMYiT6ZJ12oYcYLI8_XepT5QBd_aE8kRB0rLkcMeta } from "/codebuild/output/src2017366789/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93_45vQKittuXfxh9KJekmLJbPjZrvrqo9CPEqOomHON240Meta } from "/codebuild/output/src2017366789/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexXK0SZ4Y_45VCf0mBU5KtTwHrAxfwohKRHlk5DAe3T3S7kMeta } from "/codebuild/output/src2017366789/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeCZwujvhxDdo83ShOX9V9L9_HjPCVILUh5mQ0xb4jAYwMeta } from "/codebuild/output/src2017366789/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45code4PY80_45L_45E4WSTdDPw6YX1TGUFCI87M8ZxxqS8ZwJulAMeta } from "/codebuild/output/src2017366789/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as complete22QS7gxDrnBYad7VNcijxE_j0P_zqDtKeZvorKtCy70Meta } from "/codebuild/output/src2017366789/src/src/pages/contact-form/complete.vue?macro=true";
import { default as register9UQRAre_45HoYV1EVY6K_LFHOVALaqg7_pryTAFUJWO_4Meta } from "/codebuild/output/src2017366789/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeHS3Gpv3VbjdRTZhEMW1EE1qAvJ6eCRVQZ_45ss_z8BKfYMeta } from "/codebuild/output/src2017366789/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexmAhkNzKA25Hmoqk8hLFSsjHp99OpaqZyVyonNmKoy_45YMeta } from "/codebuild/output/src2017366789/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirm_eUAib_VEI5kA4XRnfJ_45d2u7fFk78QJZvkeGplfeeKkMeta } from "/codebuild/output/src2017366789/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as complete_45mKeB_45wSOL9lMOAz3omzkDqSwQ6sw4m40_tcRs0_FCsMeta } from "/codebuild/output/src2017366789/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexD0rUuUpGzIPADRAlwSreoOnApspKUu511_455tVV_5jYUMeta } from "/codebuild/output/src2017366789/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93DTfCBPjpszTORW9SCZT8yEkzkHGvmHsHKWZwi6x0ngQMeta } from "/codebuild/output/src2017366789/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completecUEcwJFJiXnMJ7r85qTFJzyD_45DxCaw6xGy8PTEkwTx4Meta } from "/codebuild/output/src2017366789/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliaspH16nvZC_45pWwdsQP5GFuBF1c8IAtEMLVsODDBbr07RwMeta } from "/codebuild/output/src2017366789/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sample9jF3ev_sjsfaEbKgcf4d6PnSpsnMwdeMRRFUZ8FHc8kMeta } from "/codebuild/output/src2017366789/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45email73B6zTN1uLYaRsE3bdxIFdRO2ygxAbsUww2EsZRN7igMeta } from "/codebuild/output/src2017366789/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmMD_TytUKUa_45pymfLr0wPPZXWjT0UQBX0JkVOIxj9IfQMeta } from "/codebuild/output/src2017366789/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentk_MkZR83e0rc9DmlChEigRsoZ6mReeHdknDOhb6enG0Meta } from "/codebuild/output/src2017366789/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirm4guepy_IUKn2KvAL_uRG_ZyMgb88nNRLFc81lz_45MM0cMeta } from "/codebuild/output/src2017366789/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedate62tqrik5BYLufnm0CVGLnWC03n7h9zDWhRHJkchHz0wMeta } from "/codebuild/output/src2017366789/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completey_45_jN5KLZ6NTta1ylHu7oSx651blRKDOG_45Hbiryfp7EMeta } from "/codebuild/output/src2017366789/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeBkPq2I4i88la0kMXvEEO1qQWazOHeKwREygtE2cdDw8Meta } from "/codebuild/output/src2017366789/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordJXf8ehZmKcFP8brMEpII0Sjb5w54o46BX6PLuuZ37K0Meta } from "/codebuild/output/src2017366789/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45alias8sspeu9r_f4Lc50OC9nRUmaeSL8aTTGwQSj0xFanH9AMeta } from "/codebuild/output/src2017366789/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerOnaP5lRM8uWl0W7lndZZlClIG95xzpaBb6kbl5_45Mtd4Meta } from "/codebuild/output/src2017366789/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeT4dg7vpFmiCTBmmz0J71a5JF73gOWnoqyo38e7rfToIMeta } from "/codebuild/output/src2017366789/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as index_0QHqcGCQu0FxFewYvHkMNvbDHOn7f6O0jJiBXI5igIMeta } from "/codebuild/output/src2017366789/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexkArQjN73I32NVASsSIGPzjzoHNJ29GxoYWPfhlZpmxwMeta } from "/codebuild/output/src2017366789/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexSSa8QQ9NIplApKf4PtvunSoAlLWiw9_CIGN7SRxWc14Meta } from "/codebuild/output/src2017366789/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexXW0TOeU2bJr03_45XBDL9f8CypHjXeEo9CHievj4YcTvwMeta } from "/codebuild/output/src2017366789/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateyyiO_45vS3MY6NVKW03cAKx2scqlRumDfyT6FyahGwAw8Meta } from "/codebuild/output/src2017366789/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completerhMe0O2PG7tjdgH0_45Nm_lHP_v4vKNj2wwFVbqXzvsiEMeta } from "/codebuild/output/src2017366789/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmoGkjK_45i0KPkxlAozxqe7WQ9SCBJcR4u4eDzWHxiBpGoMeta } from "/codebuild/output/src2017366789/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexRaQ6gGRLlI_x2_Ek_v30zDhR7Ee7puqOgzfG__2tg3oMeta } from "/codebuild/output/src2017366789/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeoIzt6JfD9fEFUKg7u8O7tZPxpoWNO_45rJBaDY8zXMfCcMeta } from "/codebuild/output/src2017366789/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as update0iMQNuBz5_453xik2g_45JZFBw6V2R1AdSMcRFPBWUe8MvgMeta } from "/codebuild/output/src2017366789/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexLnjLn0NzG9_ykeJGy68udTKIs3_45zlRnCMWoK_bxQnicMeta } from "/codebuild/output/src2017366789/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexPQGIaryPAMjb8X_45nHOSKsbCxhIwsgltkJPLEGYGABRwMeta } from "/codebuild/output/src2017366789/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeUvECSxghbRGVcaJR0rLNw1Zv0arhvBcWblx_f1ELkbUMeta } from "/codebuild/output/src2017366789/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexXfRnj_Mhbw4PuoUJOkv5oiXAcDWZ5_CtUvBVmFgASwIMeta } from "/codebuild/output/src2017366789/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeKSuqgiA9SgMRvrfxKviWKXR5Rgv1QjVV7GNLerLAEgEMeta } from "/codebuild/output/src2017366789/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexO84svF_Ig0htexG00GiR7uXnSaFwcKIbUNPRbWImwCwMeta } from "/codebuild/output/src2017366789/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexOznDDcyjRIxOuN6dzzmFnXgVF6xCZJ_453KVXACRFYnScMeta } from "/codebuild/output/src2017366789/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexNxO8xUyt13nVcJFym3b04JlOnl5ZPpT9WZHkesAPCIcMeta } from "/codebuild/output/src2017366789/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatePTA949xWBmBHPZykzA78WEgHmnq6Ndo12gEZNaPJmvgMeta } from "/codebuild/output/src2017366789/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmVZ_45Ef0SmsMlNWww_45M3kDowXvrICbxWb4IxBKaIVyAfkMeta } from "/codebuild/output/src2017366789/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuZ6FUqn8XraIZrP6hqlSNSnXJWcXnLrkcGM6GKcw2DzUMeta || {},
    component: () => import("/codebuild/output/src2017366789/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexlbiEBoJ14HGlBB4_453WICk4Tz3zrw7TtZ27VATXcZzacMeta || {},
    component: () => import("/codebuild/output/src2017366789/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexgACSfaqantiA8U7pMg71Xh8ZAm_45HYgH1uD_45avF_45OU7EMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src2017366789/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src2017366789/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src2017366789/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src2017366789/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexd6JrO_LTZrH_jW6jQ73urgpwKZdZc6CcAd1J2RR0x28Meta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src2017366789/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexxTKi5MuLzvD3u4z2mirb32EV7fXURLU65AwQMwozfBIMeta || {},
    component: () => import("/codebuild/output/src2017366789/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexaesG6bEMO1cnakJX8BjBoot3O0wdaFxOf_45JIfU6XC_cMeta || {},
    component: () => import("/codebuild/output/src2017366789/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2017366789/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2017366789/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexkOolzjQs5VdSEBOJ4wqapROPrXOm4Rf_nGw2duRMpUUMeta || {},
    component: () => import("/codebuild/output/src2017366789/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src2017366789/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirm8IXThfYWoI1yaoMTv0WhKrAejsqU1h2uoHIa540T8FUMeta || {},
    component: () => import("/codebuild/output/src2017366789/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmc5jgC2jMt3LU0uiTIwgT4gth8sGImxU1Jjo6eCaycFsMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src2017366789/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeYugTRwqKKkwJrFJ684VnuuvCHqGU5pf_45ekSQEbKpB0oMeta || {},
    component: () => import("/codebuild/output/src2017366789/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerCG0iYtIUTg81FDA0LFObGzIIsdZ4mD44LehOeauhc7IMeta || {},
    component: () => import("/codebuild/output/src2017366789/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmliOpkCMYiT6ZJ12oYcYLI8_XepT5QBd_aE8kRB0rLkcMeta || {},
    component: () => import("/codebuild/output/src2017366789/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeCZwujvhxDdo83ShOX9V9L9_HjPCVILUh5mQ0xb4jAYwMeta || {},
    component: () => import("/codebuild/output/src2017366789/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45code4PY80_45L_45E4WSTdDPw6YX1TGUFCI87M8ZxxqS8ZwJulAMeta || {},
    component: () => import("/codebuild/output/src2017366789/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: complete22QS7gxDrnBYad7VNcijxE_j0P_zqDtKeZvorKtCy70Meta || {},
    component: () => import("/codebuild/output/src2017366789/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: register9UQRAre_45HoYV1EVY6K_LFHOVALaqg7_pryTAFUJWO_4Meta || {},
    component: () => import("/codebuild/output/src2017366789/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirm_eUAib_VEI5kA4XRnfJ_45d2u7fFk78QJZvkeGplfeeKkMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src2017366789/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: complete_45mKeB_45wSOL9lMOAz3omzkDqSwQ6sw4m40_tcRs0_FCsMeta || {},
    component: () => import("/codebuild/output/src2017366789/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexD0rUuUpGzIPADRAlwSreoOnApspKUu511_455tVV_5jYUMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2017366789/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completecUEcwJFJiXnMJ7r85qTFJzyD_45DxCaw6xGy8PTEkwTx4Meta || {},
    component: () => import("/codebuild/output/src2017366789/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2017366789/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sample9jF3ev_sjsfaEbKgcf4d6PnSpsnMwdeMRRFUZ8FHc8kMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2017366789/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45email73B6zTN1uLYaRsE3bdxIFdRO2ygxAbsUww2EsZRN7igMeta || {},
    component: () => import("/codebuild/output/src2017366789/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmMD_TytUKUa_45pymfLr0wPPZXWjT0UQBX0JkVOIxj9IfQMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2017366789/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentk_MkZR83e0rc9DmlChEigRsoZ6mReeHdknDOhb6enG0Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2017366789/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirm4guepy_IUKn2KvAL_uRG_ZyMgb88nNRLFc81lz_45MM0cMeta || {},
    component: () => import("/codebuild/output/src2017366789/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completey_45_jN5KLZ6NTta1ylHu7oSx651blRKDOG_45Hbiryfp7EMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2017366789/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeBkPq2I4i88la0kMXvEEO1qQWazOHeKwREygtE2cdDw8Meta || {},
    component: () => import("/codebuild/output/src2017366789/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordJXf8ehZmKcFP8brMEpII0Sjb5w54o46BX6PLuuZ37K0Meta || {},
    component: () => import("/codebuild/output/src2017366789/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2017366789/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerOnaP5lRM8uWl0W7lndZZlClIG95xzpaBb6kbl5_45Mtd4Meta || {},
    component: () => import("/codebuild/output/src2017366789/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeT4dg7vpFmiCTBmmz0J71a5JF73gOWnoqyo38e7rfToIMeta || {},
    component: () => import("/codebuild/output/src2017366789/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src2017366789/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]